<div id="setting">
    <label>{{file.get('key')?.value}}</label>
    <div class="input-container">
        <label>{{file.get('fileName')?.value}}</label>
        <div class="buttons">
            <button mat-button title="Select file" color="primary" (click)="fileInput.click()" [disabled]="!canMaintain()">
                <mat-icon svgIcon="file"></mat-icon>
                <input id="select-file-input" #fileInput type="file" accept=".json,.csv,.xslt,.pfx,.p12"
                    (change)="selectFile($event)" />
            </button>
            <button *ngIf="canMaintain() && canDownload()" color="primary" mat-button title="Download" (click)="downloadFile()">
                <mat-icon svgIcon="download"></mat-icon>
            </button>
            <button *ngIf="canMaintain() && canRemove()" color="primary" mat-button title="Delete" (click)="removeFile()">
                <mat-icon svgIcon="delete"></mat-icon>
            </button>
            <button *ngIf="canMaintain() && canSave()" color="primary" mat-button title="Save" class="filled" (click)="saveFile()">
                <mat-icon svgIcon="tick"></mat-icon>
            </button>
        </div>
    </div>
</div>